import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { DebtCollection } from '../../model/debt-collection';
import { DebtCollectionService } from '../../service/data/debt-collection.service';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { DebtCollectionCommandHandlerResolver } from '../../service/command/debt-collection-command-handler-resolver.service';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { AllowSort } from '../../../core/service/factory/allow-sort';
import { DebtCollectionCompany, DebtCollectionCompanyToString } from '../../model/const/enum';
import { CompanyService } from '../../../rent/service/data/company.service';

@Component({
    selector: 'app-debt-collection-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [DebtCollectionCommandHandlerResolver, DebtCollectionService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DebtCollectionManagerComponent extends PagedObjectManagerComponent<DebtCollection> {
  constructor(
    private _dataService: DebtCollectionService,
    private _companyService: CompanyService,
    messageService: MessageService,
    navigation: NavigationService,
    cdf: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    handlerResolver: DebtCollectionCommandHandlerResolver
  ) {
    super(_dataService, messageService, navigation, dispatcher, handlerResolver);

    this.columnDefinition = [
      cdf.create('INVOICE.INVOICE_NUMBER', 'invoiceNumber'),
      cdf.create('COMMON.COMPANY', 'company'),
      cdf.create('DEBT_COLLECTION.AGENCY_ERRAND_ID', 'agencyErrandId'),
      cdf.create('COMPANY.DEBT_COLLECTION.DEBT_COLLECTION_COMPANY', 'externalSystemName'),
      cdf.create('INVOICE.RECIPIENT_NAME', 'invoiceRecipient'),
      cdf.createMoney('COMMON.AMOUNT', 'amount'),
      cdf.createDate('DEBT_COLLECTION.CREATED_AT', 'createdAt'),
      cdf.createMoney('INVOICE.INVOICEAMOUNT', 'invoiceAmount'),
      cdf.createMoney('INVOICE.REMAINING_AMOUNT', 'unpaidInvoiceAmount'),
      cdf.createDate('INVOICE.DUE_DATE', 'invoiceDueDate'),
      cdf.create('INVOICE.PERIOD', 'invoiceRefersToPeriod', { allowSort: AllowSort.No }),
    ];

    this.allowNew = false;
    this.title = 'DEBT_COLLECTION.ERRANDS';
    this.preferencesKey = 'invoice.debt-collection.list';
  }

  ngOnInit() {
    this.AddSubscription(
      this._dataService.getFilterDefinition().subscribe({
        next: filter => {
          this.defaultFilters = filter.defaultFields;
          const yesNo = [
            { caption: 'NO_TEXT', value: false },
            { caption: 'YES_TEXT', value: true },
          ];
          var debtCollectionCompanySelection = [
            { caption: 'INVOICE.CATEGORY.ANY', value: null },
            { caption: DebtCollectionCompanyToString(DebtCollectionCompany.FastighetsagarnaMittNord), value: DebtCollectionCompany.FastighetsagarnaMittNord },
            { caption: DebtCollectionCompanyToString(DebtCollectionCompany.Preventia), value: DebtCollectionCompany.Preventia },
            { caption: DebtCollectionCompanyToString(DebtCollectionCompany.Profina), value: DebtCollectionCompany.Profina },
            { caption: DebtCollectionCompanyToString(DebtCollectionCompany.PsFinanceGroup), value: DebtCollectionCompany.PsFinanceGroup },
            { caption: DebtCollectionCompanyToString(DebtCollectionCompany.RopoCapital), value: DebtCollectionCompany.RopoCapital },
            { caption: DebtCollectionCompanyToString(DebtCollectionCompany.RopoOne), value: DebtCollectionCompany.RopoOne },
          ];
          const companies = filter.companies.map(x => {
            return { caption: x.toString(), value: x.id };
          });
          companies.splice(0, 0, { caption: 'ALL_TEXT', value: '' });

          this.filterDefinition = [
            new FilterDefinitionItem(
              'COMMON.COMPANY',
              'companyId',
              filter.companyId,
              this._companyService,
              filter.selectedFields.includes('companyId')
            ),
            new FilterDefinitionItem(
              'INVOICE.RECIPIENT_NAME',
              'contactName',
              filter.contactName,
              null,
              filter.selectedFields.includes('contactName')
            ),
            new FilterDefinitionItem('INVOICE.OCRNUMBER', 'ocr', filter.ocr, null, filter.selectedFields.includes('ocr')),
            new FilterDefinitionItem(
              'DEBT_COLLECTION.SHOW_FULLY_PAID',
              'showFullyPaid',
              filter.showFullyPaid,
              yesNo,
              filter.selectedFields.includes('showFullyPaid')
            ),
            new FilterDefinitionItem(
              'COMPANY.DEBT_COLLECTION.DEBT_COLLECTION_COMPANY',
              'externalSystem',
              filter.externalSystem,
              debtCollectionCompanySelection,
              filter.selectedFields.includes('externalSystem')
            ),
          ];
        },
        error: error => {
          this.messageService.showError(error);
        },
      })
    );
  }
}
